const sanitizeProjects = (projects) => {
    return projects.map((project) => {
        return {
            uuid: project.uuid,
            name: project.name,
            description: project.description
        };
    });
};

export { sanitizeProjects };
